import React from 'react';
import autoBind from 'react-autobind';
import { Drawer, Row, Form, InputNumber, Input, Col, Button, Select, Checkbox, message } from 'antd';
import Utils from '../../../components/Utils';
import Globals from '@/config/Globals';
import CustomComponent from '../../../components/CustomComponent';

export default class CommonApplicationRequirementDrawer extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      isVisible: false,
      requirementData: null,
      index: -1,
      isDisabled: false,
      selectedType: null,
    };
  }

  show(requirementData, index) {
    this.setState(
      {
        isVisible: true,
        requirementData,
        index: index != undefined ? index : -1,
        selectedType: requirementData?.type || null,
        isDisabled: requirementData?.isDisabled || false,
      },
      () => {
        if (requirementData) {
          this.form.setFieldsValue({
            ...requirementData,
            requirement: requirementData.id,
            equivalence: requirementData.id,
          });
        }
      }
    );
  }

  handleClose() {
    this.form.resetFields();
    this.setState({
      isVisible: false,
      requirementData: null,
      index: -1,
      isDisabled: false,
      selectedType: null,
    });
  }

  async handleSubmit() {
    const formData = await this.form.validateFields();
    if (!formData) return;
    const { selectedType, requirementData } = this.state;
    const { requirements, certificationID, isRenewal, section } = this.props;
    const type = isRenewal ? Globals.RequiremetTypes.RENEW : (selectedType || Globals.RequiremetTypes.NEW);
    const tenantID = this.props.app.sharedCache().getTenantConfig().id;
    const selectedItem =
      this.props.equivalences?.find(eq => eq.id === formData.equivalence) ||
      this.props.requirements?.find(req => req.id === formData.requirement);
    const typeData = selectedItem?.type || type;

    let updatedData = {
      id: selectedItem?.id || requirementData?.id,
      certificationID: selectedItem?.certificationID || certificationID,
      tenantID: tenantID,
      type: typeData,
      isDisabled: formData?.isDisabled ?? selectedItem?.isDisabled,
    };

    if (formData.requirement) {
      updatedData.section = section;
    }

    let action;
    if (requirementData) {
      action = formData.requirement
        ? this.updateCertRequirement(certificationID, updatedData, typeData)
        : this.updateCertEquivalence(certificationID, updatedData, typeData);
    } else {
      action = formData.requirement
        ? this.createCertRequirement(certificationID, updatedData, typeData)
        : this.createCertEquivalence(certificationID, updatedData, typeData);
    }

    const success = await action;
    if (success) {
      this.handleClose();
    }
  }

  handleEquivalenceChange(value) {
    const selectedEquivalence = this.props.equivalences.find(eq => eq.id === value);
    this.setState({
      selectedType: selectedEquivalence?.type || null,
    });
  }

  handleRequirementChange(value) {
    const selectedRequirement = this.props.requirements.find(req => req.id === value);
    this.setState({
      selectedType: selectedRequirement?.type || null,
    });
  }

  //API
  async createCertEquivalence(certificationID, requirementObj, type) {
    const response = await this.props.app.config.certEquivalency.createCertEquivalency(certificationID, requirementObj, type);
    if (response.statusCode === 200) {
      message.success('Equivalency created with success!');
      this.props.fetchData();
      return true;
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, response);
      return false;
    }
  }

  async updateCertEquivalence(certificationID, requirementObj, type) {
    const response = await this.props.app.config.certEquivalency.updateCertEquivalency(certificationID, requirementObj, type);
    if (response.statusCode === 200) {
      message.success('Equivalency updated with success!');
      this.props.fetchData();
      return true;
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, response);
      return false;
    }
  }

  async createCertRequirement(certificationID, requirementObj, type) {
    const response = await this.props.app.config.certRequirement.createCertRequirement(certificationID, requirementObj, type);
    if (response.statusCode === 200) {
      message.success('Requirement created with success!');
      this.props.fetchData();
      return true;
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, response);
      return false;
    }
  }

  async updateCertRequirement(certificationID, requirementObj, type) {
    const response = await this.props.app.config.certRequirement.updateCertRequirement(certificationID, requirementObj, type);
    if (response.statusCode === 200) {
      message.success('Requirement updated with success!');
      this.props.fetchData();
      return true;
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, response);
      return false;
    }
  }

  // UI 
  render() {
    const { equivalences, requirements, existingItems } = this.props;
    const { requirementData } = this.state;
    const filteredEquivalences = equivalences?.filter(eq =>
      !existingItems.some(item => item.id === eq.id)
    );
    const filteredRequirements = requirements?.filter(req =>
      !existingItems.some(item => item.id === req.id)
    );

    return (
      <Drawer
        open={this.state.isVisible}
        title={`${requirementData ? 'Edit' : 'Create'} Requirement`}
        placement="right"
        onClose={this.handleClose}
        width={600}
        footer={
          <Row justify="start" style={{ marginBottom: 0 }}>
            <Col>
              <Button onClick={this.handleClose} style={{ marginRight: 8 }}>
                Cancel
              </Button>
              <Button type="primary" onClick={this.handleSubmit}>
                Save
              </Button>
            </Col>
          </Row>
        }
      >
        <Form layout="vertical" {...Utils.propagateRef(this, 'form')}>
          {requirements && requirements.length > 0 && (
            <Row>
              <Col span={12}>
                <Form.Item name="requirement" label="Requirement">
                  <Select
                    onChange={this.handleRequirementChange}
                    value={this.state.requirementData?.id}
                    disabled={!!this.state.requirementData}
                  >
                    {filteredRequirements.map(req => (
                      <Select.Option key={req.id} value={req.id}>
                        {req.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

              </Col>
            </Row>
          )}
          {equivalences && equivalences.length > 0 && (
            <Row>
              <Col span={12}>
                <Form.Item name="equivalence" label="Equivalence">
                  <Select
                    onChange={this.handleEquivalenceChange}
                    value={this.state.requirementData?.id}
                    disabled={!!this.state.requirementData}
                  >
                    {filteredEquivalences.map(eq => (
                      <Select.Option key={eq.id} value={eq.id}>
                        {eq.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )}
          <Row>
            <Col span={12}>
              <Form.Item name="isDisabled" valuePropName="checked">
                <Checkbox
                  onChange={e => this.setState({ isDisabled: e.target.checked })}
                >
                  Disabled
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    );
  }
}
